export default "/images/talk.svg?1254556120c252c31e9239e206115a4e";